import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/accessibility-statement')({
  ssr: false,
})
